import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import _ from 'underscore';
import '../../styles/devices.css';

class JobList extends Component {

    constructor(props) {
        super(props);

        this.onDetails = this.onDetails.bind(this);
    }

    onDetails(job, event) {

        event.preventDefault();
        let { status } = this.props;
        if (status === 'closed')
            browserHistory.push(`job/${job.jobID}`);
        else
            browserHistory.push(`booking/${job.jobID}`);
        
    }



    render() {
        const groupedJobs = _.groupBy(this.props.jobs, "terminalID");

        return (
            <div>
                {_.map(groupedJobs, function (g, key) {
                    return (
                        <div className="card-slim" key={key} onClick={g.length == 1 ? this.onDetails.bind(this, g[0]) : null}>
                            <div className="text-center">
                                <div className={"device " + (g[0].deviceType.replace(" ", "-") || "").toLowerCase()} />
                                <h3 className="m-t-0 m-b-5">{g[0].deviceType}</h3>
                                <p>{g[0].terminalID}</p>
                            </div>
                            <ul className="job-list">
                                {_.map(g, function (job) {
                                    return (
                                        <li key={job.jobID} onClick={g.length > 1 ? this.onDetails.bind(this, job) : null}>
                                            <i className="fa fa-wrench m-r-15" />
                                            <i className="fa fa-caret-right list-caret" />
                                            <span>
                                                {job.jobID}
                                                <span className="label label-default m-l-10">Install</span>
                                            </span>
                                        </li>
                                    );
                                }.bind(this))}
                            </ul>
                        </div>
                    );
                }.bind(this))}
            </div>
        );
    }
}

export default JobList;


// WEBPACK FOOTER //
// ./app/jobs/components/jobList.js